import React from 'react';

export const LoadingSpinnerIcon: React.FC = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" stroke="#e5e7eb" strokeWidth="4" />
        <path d="M24 4 A20 20 0 0 1 44 24" stroke="#f59e0b" strokeWidth="4" strokeLinecap="round" />
    </svg>
);
